import * as React from 'react';

type Props = {
  error: Error | string;
  children?: React.ReactNode;
};

class ErrorReporter extends React.Component<Props> {
  componentDidMount() {
    console.debug(this.props.error);
    console.error(this.props.error.toString());
  }

  render() {
    return this.props.children || null;
  }
}

export default ErrorReporter;
